import { _ as _typeof } from '../typeof-c772fc8d.js';

var IS_BROWSER = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';

export { IS_BROWSER as default };
//# sourceMappingURL=index.js.map
